import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { Button as SerendieButton } from "@serendie/ui";
import "./Styles.scss";

export class Button extends BaseComponent<IButtonProps, IButtonState>
{
    public render(): JSX.Element
    {
        const classNames: string[] = [];
        classNames.push(this.props.className ?? '');
        classNames.push('serendie-button');
        classNames.push(this.props.size == 'small' ? 'serendie-button--small' : '');
        classNames.push(this.props.color == 'error' ? 'serendie-button--error' : '');
        classNames.push(this.props.styleType == 'filled' ? 'serendie-button--filled' : '');

        return <SerendieButton
            {...this.props}
            className={classNames.join(' ')}
        />
    }
}

export type IButtonProps = React.ComponentProps<typeof SerendieButton>;
export interface IButtonState { }
